<div class="step-container">
  <h3 class="step-title">Stripe Connect</h3>
  <p class="step-subtitle">
    Connect your organization to Stripe to start accepting donations and payments.
    You'll be redirected to Stripe's secure onboarding to provide banking and identity information.
  </p>

  <!-- Status Badge -->
  <div class="status-card" [class]="'status-' + stripeStatus">
    <div class="status-row">
      <mat-icon class="status-icon">
        {{ isActive ? 'check_circle' : (stripeStatus === 'none' ? 'radio_button_unchecked' : 'pending') }}
      </mat-icon>
      <div class="status-info">
        <span class="status-label">Stripe Connect Status</span>
        <span class="status-value">{{ statusLabel }}</span>
      </div>
      <button
        mat-icon-button
        (click)="refreshStatus()"
        [disabled]="isLoadingStatus || !stripeAccountId"
        title="Refresh status"
      >
        <mat-spinner *ngIf="isLoadingStatus" diameter="20"></mat-spinner>
        <mat-icon *ngIf="!isLoadingStatus">refresh</mat-icon>
      </button>
    </div>

    <div *ngIf="stripeAccountId" class="account-id">
      <span class="label">Account ID:</span>
      <code>{{ stripeAccountId }}</code>
    </div>
  </div>

  <!-- Requirements -->
  <div *ngIf="statusDetails?.requirements?.currently_due?.length > 0" class="requirements-card">
    <h4>
      <mat-icon>warning</mat-icon>
      Action Required
    </h4>
    <ul>
      <li *ngFor="let item of statusDetails.requirements.currently_due">
        {{ formatItem(item) | titlecase }}
      </li>
    </ul>
  </div>

  <!-- What Stripe Collects -->
  <div *ngIf="!isActive" class="info-card">
    <h4>What Stripe will collect during onboarding:</h4>
    <div class="info-items">
      <div class="info-item">
        <mat-icon>account_balance</mat-icon>
        <span>Bank account details for payouts</span>
      </div>
      <div class="info-item">
        <mat-icon>business</mat-icon>
        <span>Business verification documents</span>
      </div>
      <div class="info-item">
        <mat-icon>person</mat-icon>
        <span>Representative identity verification</span>
      </div>
      <div class="info-item">
        <mat-icon>lock</mat-icon>
        <span>All data is processed securely by Stripe</span>
      </div>
    </div>
  </div>

  <!-- Active State -->
  <div *ngIf="isActive" class="success-card">
    <mat-icon>verified</mat-icon>
    <div>
      <strong>Stripe Connect Active</strong>
      <p>Your organization can now accept donations and receive payouts to your bank account.</p>
    </div>
  </div>

  <div class="form-actions">
    <!-- Not yet started -->
    <button
      *ngIf="stripeStatus === 'none'"
      mat-raised-button
      color="primary"
      (click)="createAndConnect()"
      [disabled]="isCreatingAccount || isRedirecting"
    >
      <mat-spinner *ngIf="isCreatingAccount || isRedirecting" diameter="20" class="btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!isCreatingAccount && !isRedirecting">open_in_new</mat-icon>
      <span>{{ isCreatingAccount ? 'Creating account...' : isRedirecting ? 'Redirecting to Stripe...' : 'Connect with Stripe' }}</span>
    </button>

    <!-- Incomplete / pending — resume -->
    <button
      *ngIf="stripeStatus === 'pending' || stripeStatus === 'incomplete'"
      mat-raised-button
      color="accent"
      (click)="resumeOnboarding()"
      [disabled]="isRedirecting"
    >
      <mat-spinner *ngIf="isRedirecting" diameter="20" class="btn-spinner"></mat-spinner>
      <mat-icon *ngIf="!isRedirecting">open_in_new</mat-icon>
      <span>{{ isRedirecting ? 'Redirecting...' : 'Resume Stripe Onboarding' }}</span>
    </button>

    <!-- Active — continue -->
    <button
      *ngIf="isActive"
      mat-raised-button
      color="primary"
      (click)="onContinue()"
    >
      <mat-icon>arrow_forward</mat-icon>
      <span>Continue</span>
    </button>

    <!-- Skip if active or we want to proceed anyway -->
    <button
      *ngIf="!isActive"
      mat-stroked-button
      (click)="onContinue()"
      [disabled]="isCreatingAccount || isRedirecting"
    >
      Skip for now
    </button>
  </div>
</div>
